import { DEFAULT_TIME_IN_SECONDS_FOR_UPDATE_INTERVAL, UPDATE_TYPE } from '@constants'

import { FormValues } from '../types'

export const getDefaultValues = (): FormValues => {
  return {
    id: '',
    method: 'GET',
    code: '',
    title: '',
    editable: false,
    multiselection: false,
    object: null,
    commands: [],
    viewIds: [],
    url: '',
    dataType: 'json',
    isJsTitle: false,
    titleJsValue: '',
    contextMenu: null,
    prefilter: '',
    update: '',
    updateSetting: {
      type: UPDATE_TYPE.WEBSOCKET,
      interval: DEFAULT_TIME_IN_SECONDS_FOR_UPDATE_INTERVAL,
    },
    columnGroups: [],
  }
}
